import React, { useCallback } from "react";
import { InputField, DropDown } from 'KN-EU-Broker-Dashboard-UI';
import {Grid} from 'semantic-ui-react';
import List from "../../commonComponents/List";


const HeaderTabForm3 = ({formData}) => {
    const {orgRevenueDetails={}, reconRevenueDetails={}} = formData;

    return (
        <Grid className="responsiveGridCss1" data-reducer="updateHeaderTab">
            {Object.keys(orgRevenueDetails).map((item, index) => {
                const{ revenueAmount:orgRevenue, accountingClassName } = orgRevenueDetails[item];
                const{ revenueAmount:reconRevenue } = reconRevenueDetails[item];
                return (
                <Grid.Row>
                    <Grid.Column>
                        <InputField 
                            label={`Original ${item}`}
                            name={`orgRevenueDetails.${item}.revenueAmount`}
                            value={orgRevenue}
                            isDisabled={true}
                        />
                    </Grid.Column>
                    <Grid.Column className="headerTabGridColumn noRightBorders">
                        <InputField 
                            label={`Reconciled ${item}`}
                            value={reconRevenue}
                            isDisabled={true}
                        />
                    </Grid.Column>
                    <Grid.Column className="headerTabGridColumnLast">
                        <InputField 
                            label='Difference'
                            value={(orgRevenue-reconRevenue).toFixed(2)}
                            isDisabled={true}
                        />
                    </Grid.Column>
                </Grid.Row>)
            })}
        </Grid>
    )
}
 
export default HeaderTabForm3;